import React from 'react';
import {Stack, Typography} from '@mui/material';

/**
 * Table header component for reports list
 * @param {Array} columns - Array of column configurations
 */
const TableHeader = ({columns}) => {
    return (
        <Stack
            direction="row"
            spacing={2}
            px={2}
            py={1}
            bgcolor="#e9ecef"
            overflow="hidden"
        >
            {columns.map((column) => (
                <Typography key={column.field} flex={column.flex} fontWeight="bold">
                    {column.headerName}
                </Typography>
            ))}
            {/* Placeholder for actions column */}
            <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ml: 'auto', width: '30px'}}>
                {/* Empty space for menu button alignment */}
            </Stack>
        </Stack>
    );
};

export default TableHeader;
